import * as React from "react";

export default () => {
  return <div>Ange hur parkeringsmöjligheterna ser ut för objekten.</div>;
};
